import { render, staticRenderFns } from "./BurgerBlock.vue?vue&type=template&id=8d60c8e0&scoped=true&"
import script from "./BurgerBlock.vue?vue&type=script&lang=js&"
export * from "./BurgerBlock.vue?vue&type=script&lang=js&"
import style0 from "./BurgerBlock.vue?vue&type=style&index=0&id=8d60c8e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d60c8e0",
  null
  
)

export default component.exports